import React from 'react';
import { Helmet } from 'react-helmet-async';
import seoHelpers from '../config/seo';

const { getBusinessSchema } = seoHelpers;

const SchemaMarkup = () => (
  <Helmet>
    <script id="academy-schema" type="application/ld+json">
      {JSON.stringify(getBusinessSchema()).replace(/</g, '\\u003c')}
    </script>
  </Helmet>
);

export default SchemaMarkup;
